import { api } from "@verbleif/shared/src/composables/Api/api";

/**
 * Ends an impersonation session on the impersonated person's audit trail (`POST /api/me/impersonation/stop`). Sent
 * without `X-Switch-User`, as the staff member. A failure never blocks stopping: the session then only lacks its
 * stop entry.
 */
export async function reportImpersonationStopped(impersonatedUserId: number): Promise<void> {
  await api.post("/api/me/impersonation/stop", { user: impersonatedUserId }).catch(() => undefined);
}
